import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TableBody } from './TableBody';
import { TableFooter } from './TableFooter';
import { TableHeader } from './TableHeader';
import styles from './styles.module.scss';
export function BoqTable() {
    return (_jsxs("div", { className: styles.tableContainer, children: [_jsx(TableHeader, {}), _jsx("div", { children: _jsx(TableBody, {}) }), _jsx(TableFooter, {})] }));
}
